module.exports = __webpack_public_path__ + "static/media/general-m.1707c7e8.svg";